import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { AnalyticsEvent } from '~/modules/services/analyticsService';
import { GtmEventType } from './gtmEventType';

export type SignUpAnalyticsEvent = {
    authenticationMethod: string;
    userId: string;
    company: string;
    relationship: string;
    role: string;
    timestamp: number;
    authenticationOrigin: string;
    eventType: string;
} & AnalyticsEvent;

export class GtmSignupType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_AUTHENTICATION && event.eventType === 'signup';
    }

    // @ts-expect-error * Automated Type Error Fix
    getBody(event): AuthenticationEvent {
        return {
            event: 'custEv_signup',
            authentication_method: event.authenticationMethod,
            authentication_type: 'tbid',
        };
    }
}
